<!-- Display active content filters as v-chips. -->

<template>
  <v-layout
    v-if="anyActiveFilter"
    align-center
    wrap
  >
    <v-chip
      v-if="contentsQuery.radio && showRadioChip"
      small
      close
      outline
      color="msr"
      @input="resetRadio()"
    >
      <v-icon
        small
        left
        color="msr"
      >
        music_note
      </v-icon>
      {{ 'Radio ' + $t('spots') }}
    </v-chip>
    <v-chip
      v-if="contentsQuery.tv && showTVChips"
      small
      close
      outline
      color="msr"
      @input="resetTV()"
    >
      <v-icon
        small
        left
        color="msr"
      >
        tv
      </v-icon>
      {{ 'TV ' + $t('clips') }}
    </v-chip>
    <v-chip
      v-if="contentsQuery.tickers && showTVChips"
      small
      close
      outline
      color="msr"
      @input="resetTickers()"
    >
      <v-icon
        small
        left
        color="msr"
      >
        sms
      </v-icon>
      {{ 'TV ' + $t('tickers') }}
    </v-chip>
    <v-chip
      v-if="contentsQuery.editableOnly"
      small
      close
      outline
      color="msr"
      @input="resetEditableOnly()"
    >
      <v-icon
        small
        left
        color="msr"
      >
        edit
      </v-icon>
      {{ $t('editableOnly') }}
    </v-chip>
    <v-chip
      v-if="contentsQuery.onAirOnly"
      small
      close
      outline
      color="msr"
      @input="resetOnAirOnly()"
    >
      <on-air-indicator
        class="left"
        :show-tooltip="false"
        :is-on-air="true"
        :is-planned-to-air="true"
      />
      {{ $t('onAirOnly') }}
    </v-chip>
    <v-chip
      v-if="contentsQuery.unpublishedOnly"
      small
      close
      outline
      color="msr"
      @input="resetUnpublishedOnly()"
    >
      <v-icon
        small
        left
        color="msr"
      >
        visibility_off
      </v-icon>
      {{ $t('unpublishedOnly') }}
    </v-chip>
    <v-chip
      v-if="contentsQuery.publishedOnly"
      small
      close
      outline
      color="msr"
      @input="resetPublishedOnly()"
    >
      <v-icon
        small
        left
        color="msr"
      >
        visibility
      </v-icon>
      {{ $t('publishedOnly') }}
    </v-chip>
    <v-chip
      v-if="contentsQuery.minDate || contentsQuery.maxDate"
      small
      close
      outline
      color="msr"
      @click.stop="emitOpenContentsDateFilterMenu()"
      @input="resetDates()"
    >
      <v-icon
        small
        left
        color="msr"
      >
        today
      </v-icon>
      <span v-if="contentsQuery.minDate">
        {{ $t('from') }}:&nbsp;<b>{{
          contentsQuery.minDate | dayjs('DD.MM.YYYY')
        }}</b>
      </span>
      <span
        v-if="contentsQuery.minDate && contentsQuery.maxDate"
        class="mx-1"
      />
      <span v-if="contentsQuery.maxDate">
        {{ $t('to') }}:&nbsp;<b>{{
          contentsQuery.maxDate | dayjs('DD.MM.YYYY')
        }}</b>
      </span>
    </v-chip>
    <v-chip
      v-for="groupId in contentsQuery.selectedGroupIds"
      :key="groupId"
      small
      close
      outline
      color="msr"
      @input="removeGroupFilterById(groupId)"
    >
      {{ getGroupFromId(groupId).name }}
    </v-chip>
  </v-layout>
</template>

<script>
import OnAirIndicator from '@/components/OnAirIndicator';

export default {
  components: {
    OnAirIndicator,
  },
  props: {
    /**
     * Some chips can be hidden e.g. when the filter is always on
     * implicitly, as is when adding content to a tv or radio decoder.
     */
    showRadioChip: {
      type: Boolean,
      default: true,
    },
    showTVChips: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    contentsQuery() {
      return this.$store.state.common.contentsQuery;
    },
    anyActiveFilter() {
      return (
        (this.contentsQuery.radio && this.showRadioChip) ||
        (this.contentsQuery.tv && this.showTVChips) ||
        (this.contentsQuery.tickers && this.showTVChips) ||
        this.contentsQuery.onAirOnly ||
        this.contentsQuery.unpublishedOnly ||
        this.contentsQuery.publishedOnly ||
        this.contentsQuery.minDate ||
        this.contentsQuery.maxDate ||
        this.contentsQuery.selectedGroupIds
      );
    },
  },
  methods: {
    emitOpenContentsDateFilterMenu() {
      this.$bus.$emit('usercontents-date-filter-open-menu');
    },
    getGroupFromId(groupId) {
      for (let group of this.$store.getters.accessibleGroups) {
        if (group.id === groupId) {
          return group;
        }
      }
    },
    resetRadio() {
      this.$store.commit('SET_CONTENTS_QUERY_RADIO', null);
    },
    resetTV() {
      this.$store.commit('SET_CONTENTS_QUERY_TV', null);
    },
    resetTickers() {
      this.$store.commit('SET_CONTENTS_QUERY_TICKERS', null);
    },
    resetOnAirOnly() {
      this.$store.commit('SET_CONTENTS_QUERY_ON_AIR_ONLY', null);
    },
    resetEditableOnly() {
      this.$store.commit('SET_CONTENTS_QUERY_EDITABLE_ONLY', null);
    },
    resetUnpublishedOnly() {
      this.$store.commit('SET_CONTENTS_QUERY_UNPUBLISHED_ONLY', null);
    },
    resetPublishedOnly() {
      this.$store.commit('SET_CONTENTS_QUERY_PUBLISHED_ONLY', null);
    },
    resetDates() {
      this.$store.commit('SET_CONTENTS_QUERY_MIN_DATE', null);
      this.$store.commit('SET_CONTENTS_QUERY_MAX_DATE', null);
    },
    removeGroupFilterById(groupId) {
      this.$store.commit('REMOVE_CONTENTS_QUERY_SELECTED_GROUP_ID', groupId);
    },
  },
};
</script>

<style scoped>
.left {
  margin-left: -8px;
  margin-right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentTypeFilterActiveChips.vue